// MFA styles
import { terracotta, emeraldGreen } from "Constants/ColourConstants";

export const styles = {
  dialogPaper: {
    "& .MuiDialog-container": {
      "& .MuiPaper-root": {
        width: "100%",
        minWidth: 300,
        maxWidth: 725,
      },
    },
  },
  dialogTitle: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
    alignItems: "center",
  },
  dialogTitleText: {
    color: emeraldGreen,
    fontWeight: "600",
    fontSize: "20px",
    textAlign: "left",
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  dialogContentText: {
    color: "#6B6B6B",
    fontWeight: "400",
    fontSize: "16px",
    textAlign: "left",
  },
  radioGroup: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "10px",
  },
  radioButton: {
    "&.Mui-checked": {
      color: terracotta,
    },
  },
  mfaButtons: {
    padding: "4px 24px 24px",
    justifyContent: { xs: "center", sm: "flex-end" },
    alignItems: "center",
    gap: "1rem",
    flexDirection: { xs: "column-reverse", sm: "row" },
  },
  submitButton: {
    minWidth: { xs: "200px", sm: "150px" },
  },
  backButton: {
    backgroundColor: terracotta,
    width: 100,
    borderRadius: 30,
    justifyContent: "space-between",
  },
};
